/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const MsvTestimonial = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="Trustpair"
      title={t('How Trustpair Prevents B2B Payment Fraud')}
      summary={t(
        "Trustpair runs real-time KYB verification to stop B2B payment fraud before it happens — verifying who's actually behind a seller or supplier before money moves.",
      )}
      href="/how-trustpair-prevents-b2b-payment-fraud-with-real-time-kyb-verification-from-global-database"
    />
  );
};
